import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "../../assets/svgs";
import CustomButton from "../CustomButton";
import CurrencyText from "../CurrencyText";
import { filterRemainingAssets } from "../../utils";

import "./styles.scss";

const AvailableAssetsCard = ({
  rightIcon,
  heading,
  description,
  progressLabel,
  assetsCardHeading,
  assets,
  remainingLabel,
  selectedAssets,
  onClickButton = () => {},
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  const remainingAssets = filterRemainingAssets(assets, selectedAssets);

  const remainingValue = useMemo(() => {
    if (!remainingAssets || remainingAssets.length === 0) return 0;

    return remainingAssets.reduce((sum, item) => {
      if (!item?.limitAmount) return sum;
      const cleaned = item.limitAmount
        .toString()
        .replace(/sar/gi, "")
        .replace(/[^\d.-]/g, "");
      const num = Number(cleaned);
      return !isNaN(num) ? sum + num : sum;
    }, 0);
  }, [remainingAssets]);

  const percentage = useMemo(() => {
    const totalAssets = assets.flat().length;
    const selectedCount = selectedAssets.length;
    if (totalAssets === 0) return 0;
    const value = (selectedCount / totalAssets) * 100;
    return Number.isInteger(value) ? value.toString() : value.toFixed(2);
  }, [assets, selectedAssets]);

  return (
    <div className="available-assets-card-container">
      <div className="card-heading-container">
        <div className="card-icon-container">
          <img src={rightIcon} alt="right icon" className="card-icon" />
        </div>
        <p className="card-heading">{t(`${routeName}.${heading}`)}</p>
      </div>
      <p className="card-description">
        {t(`${routeName}.${description}`, { percentage: percentage })}
      </p>
      <div
        className="card-progress-container"
        style={{ marginBottom: percentage == 100 ? "0px" : "1rem" }}
      >
        <div className="progress-label-container">
          <div className="progress-label">
            {t(`${routeName}.${progressLabel}`)}
          </div>
          <div className="progress-percentage">{percentage}%</div>
        </div>
        <div className="progress-track">
          <div
            className="progress-fill"
            style={{ width: `${percentage}%` }}
          ></div>
        </div>
      </div>
      {percentage != 100 ? (
        <>
          <hr className="separator" style={{ color: "#E4ECF4" }} />
          <div className="assets-card">
            <p className="assets-card-heading">
              {t(`${routeName}.${assetsCardHeading}`, {
                number: remainingAssets.length,
              })}
            </p>
            {remainingAssets.map((item) => {
              return (
                <div className="assets-item">
                  <span className="assets-item-label">
                    {`${item.assetBrand} ${item.assetType}`}
                  </span>
                  <CurrencyText
                    className="assets-item-value"
                    value={item.limitAmount}
                    iconPosition="right"
                  />
                </div>
              );
            })}
            <hr className="separator" />
            <div className="assets-remaining-container">
              <span className="remaining-label">
                {t(`${routeName}.${remainingLabel}`)}
              </span>
              <CurrencyText
                className="remaining-value"
                value={remainingValue}
                iconPosition="right"
              />
            </div>
          </div>
          <CustomButton
            text={t("company-details.lease_remaining_assets")}
            onClick={onClickButton}
            buttonClassName={"mb-0"}
            rightIcon={ArrowRight}
          />
        </>
      ) : null}
    </div>
  );
};

export default AvailableAssetsCard;
